/**
 * src/api/storageRequestHelpers.js
 *
 * Shared read-with-fallback helper for the storage layer. Collapses the
 * repeated try { await azureGet(...) } catch (e) { console.error; return
 * fallback } pattern used by the lenient reads in storage-azure.js.
 *
 * Not a storage operation components call (STG-B-001) — this is a plumbing
 * helper for the storage-azure implementation, not a storage operation.
 */

export async function safeRead(label, fn, fallback) {
  try {
    return await fn();
  } catch (e) {
    console.error(`[storage-azure] ${label} failed:`, e.message);
    return fallback;
  }
}
